const Eloquent = window.Eloquent;

/**
 * Register user
 * @param {Object} data
 * @returns {Promise}
 */
export function register(data) {
    return Eloquent.Auth.register(data);
}


/**
 * Login user with email and password
 * @param {String} email
 * @param {String} password
 * @returns {Promise}
 */
export function login(email, password) {
    return Eloquent.Auth.login(email, password);
}


/**
 * Logout user
 * @returns {Promise}
 */
export function logout() {
    return Eloquent.Auth.logout();
}


/**
 * Check if email is registered in the system
 * @param {String} email
 * @returns {Promise}
 */
export function checkEmail(email) {
    return Eloquent.Auth.checkEmail(email);
}


/**
 * Send reset password link
 * @param {String} email
 * @returns {Promise}
 */
export function sendResetPasswordCode(email) {
    return Eloquent.Auth.sendResetPasswordCode(email);
}


/**
 * Check reset password link token status
 * @param {String} token
 * @returns {Promise}
 */
export function checkResetPasswordCode(token) {
    return Eloquent.Auth.checkCode(token);
}


/**
 * Reset with new password and reset token
 * @param {String} token
 * @param {String} password
 * @returns {Promise}
 */
export function resetPassword(token, password) {
    return Eloquent.Auth.resetPassword(token, password);
}

/**
 * Create OTP
 * @param {Number} type 1: SMS | 2: Voice Call
 * @returns {Promise}
 */
export function createOTP(type) {
    return Eloquent.Auth.createOTP({ type });
}

/**
 * Validate OTP code
 * @param {String} code
 * @returns {Promise}
 */
export function validateOTP(code) {
    return Eloquent.Auth.validateOTP({ otp: code });
}
